import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Variant } from "src/models/variant";
import { StructureService } from 'src/services/structure/structure.service';
import { PadLeadingZerosPipe } from 'src/pipes/padleadingzeros/padleadingzeros.pipe';
import { ProvisionChange } from 'src/models/provisionchange';
import { ProvisionItem } from 'src/models/provisionitem';
import { Alternative } from 'src/models/alternative';
import { ProvisionService } from 'src/services/provision/provision.service';


@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'conversion-alternative',
  templateUrl: './alternative.component.html',
  styleUrls: ['./alternative.component.css']
})

export class AlternativeComponent {
  @Input() alternative: Alternative;
  @Output() applied = new EventEmitter<void>();

  changes: Array<ProvisionChange> = new Array<ProvisionChange>();
  padleadingzerosPipe: PadLeadingZerosPipe = new PadLeadingZerosPipe();

  constructor(private provisionService: ProvisionService) { }


  selectExecution(currentexecution: Variant, newexecution: ProvisionItem) {
    let newChange = new ProvisionChange('FPC', currentexecution.Family, currentexecution.FamilyDescription, currentexecution.Execution, currentexecution.ExecutionDescription, newexecution.Execution, newexecution.ExecutionDescription);

    var existingChange = this.changes.find(x => x.Family === newChange.Family && x.Type === newChange.Type);
    let index;
    if ((index = this.changes.indexOf(existingChange)) >= 0) {
      this.changes[index] = newChange;
    } 
    else {
      this.changes.push(newChange);
    }
    // trigger change detection in SelectConfiguration
    this.changes = this.changes.concat([]);
  }

  applySuggestion(): void {
    if (!this.alternative.Variants.length || this.changes.length !== this.alternative.Variants.length) { return; }
    this.provisionService.insertChange(this.changes);
    this.applied.emit();
  }
}
